module.exports = __webpack_public_path__ + "assets/img/description-3-fb6329bc.png";